<script lang="ts">
  import type { OrderOption } from "../../models/order-options.interface";
  import { orderStore } from "../../services/order-options-service";
  import OptionRow from "./OptionRow.svelte";

  const id = "includeattributes";
  export let option: OrderOption;

  // Default options
  orderStore.setOrderValue(
    id,
    option.params.defaultValues.map((dv) => {
      return {
        id: id,
        value: dv,
        selected: true
      };
    })
  );

  function handleRadioChange(selectedValue: string) {
    orderStore.setOrderValue(id, [
      {
        id: id,
        value: selectedValue,
        selected: true
      }
    ]);
  }
</script>

<OptionRow
  {id}
  label="Include Attributes"
  tooltip="Select 'Yes' or 'No' for data attributes to be included in your order (CSV only)."
>
  <div class="radio-container">
    {#each option.params.values as possibleValue}
      <div class="radio-item">
        <input
          type="radio"
          class="form-check-input"
          name={id}
          id="{id}-{possibleValue}"
          checked={$orderStore.values[id]?.find((o) => o.value === possibleValue)?.selected}
          on:change={() => handleRadioChange(possibleValue)}
        />
        <label class="form-check-label ms-2" for="{id}-{possibleValue}">
          {possibleValue}
        </label>
      </div>
    {/each}
  </div>
</OptionRow>

<style>
  .radio-container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
  }

  .radio-item {
    display: flex;
    align-items: center;
  }
</style>
